export const TooltipExtraTable = ({ hoveredItemId }) => {
    return (
        <div className="extra_table_section" style={{ marginTop: "10px" }}>
            <table className="extra-table">
                <thead>
                    <tr>
                        <th>Package</th>
                        <th>Left Count</th>
                        <th>Right Count</th>
                        <th>Left Carry</th>
                        <th>Right Carry</th>
                    </tr>
                </thead>
                <tbody>
                    {hoveredItemId.tooltipData.extraTableData.map((row, index) => (
                        <tr key={index}>
                            <td>{row.package}</td>
                            <td>{row.leftCount}</td>
                            <td>{row.rightCount}</td>
                            <td>{row.leftCarry}</td>
                            <td>{row.rightCarry}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}